import { render, staticRenderFns } from "./Commodity.vue?vue&type=template&id=2bc27290&"
import script from "./Commodity.vue?vue&type=script&lang=ts&"
export * from "./Commodity.vue?vue&type=script&lang=ts&"
import style0 from "./Commodity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports